<template>
	<BaseCmsPage>
		<BaseThemeWebshopPageContent />
		<div class="base-webshop-page-modules">
			<ClientOnly>
				<LazyBaseThemeWebshopAlternatePayments v-if="altPayments" />
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</div>
	</BaseCmsPage>
</template>

<script setup>
	const altPayments = __ALT_PAYMENTS__;
</script>
